// extracted by mini-css-extract-plugin
export var leftAlign = "_13-2";
export var popper = "_13-0";
export var subtitle = "_13-1";